import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Typography$1 from '../../basics/Typography/Typography.js';

const highlightedPart = /\*\*(.*?)\*\*/g;
const SpecialHeadline = React$1.forwardRef(({
  text,
  as,
  className,
  isVisible,
  reveal,
  revealVariant,
  transform,
  variant
}, ref) => {
  const updatedText = text && text.replace(highlightedPart, '<span class="typography__highlight">$1</span>');
  const typoProps = {
    as,
    className,
    isVisible,
    reveal,
    transform,
    variant,
    revealVariant
  };
  return /*#__PURE__*/React$1.createElement(Typography$1, typoProps, /*#__PURE__*/React$1.createElement("span", {
    ref: ref // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: updatedText
    }
  }));
});
SpecialHeadline.displayName = 'SpecialHeadline';
SpecialHeadline.propTypes = {
  text: PropTypes$1.string.isRequired,
  revealVariant: PropTypes$1.oneOf(['primary', 'secondary']),
  as: PropTypes$1.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  className: PropTypes$1.string,
  isVisible: PropTypes$1.bool,
  reveal: PropTypes$1.bool,
  transform: PropTypes$1.oneOf(['uppercase', 'lowercase']),
  variant: PropTypes$1.oneOf(['copy', 'intro', 'small', 'headline', 'hero', 'subline', 'quote', 'quoteBig', 'subheadline', 'copyIntro'])
};
SpecialHeadline.defaultProps = {
  as: 'h1',
  revealVariant: 'primary',
  className: '',
  isVisible: true,
  reveal: false,
  transform: null,
  variant: 'headline'
};

export default SpecialHeadline;
